import React from 'react';
import formatPrice from '../func/formatPrice';

const CurrentName = ({ lineBreakInCurrentName=true, formValue, currValue, formName, currName, isPrice }) => {
    if (typeof formValue === 'boolean') {
        currName = currName ? 'ja' : 'nein';
        formName = formName ? 'ja' : 'nein';
    }
    let current, fromForm;
    if (isPrice) {
        current = formatPrice(currName) + ' €';
        fromForm = formatPrice(formName) + ' €';
    }
    else {
        current = currName;
        fromForm = formName;
    }

    return (
        <span className='cursor-pointer'>
            {formValue === currValue
            ?
                <span className='text-small-light'>{current}</span>
            :
                <>
                    <span className='line-through text-small-light'>{fromForm}</span>
                    {lineBreakInCurrentName && <br />}
                    <span className='edited text-small-regular'>{current}</span>
                </>
            }
            <span className="edit-btn-icon"><span className="screen-reader-text">edit</span></span>
        </span>
    );
}

export default CurrentName;